import List, { ListProps } from '@liquidweb-dev/undercurrent/List';

const Wrapper = ({ children, sx, ...rest }: ListProps) => (
	<List
		sx={{
			display: 'flex',
			flexDirection: 'column',
			borderColor: ({ vars }) => vars.palette.uc.border.weak,
			maxHeight: 'none',
			flexGrow: 1,
			...sx,
		}}
		{...rest}
	>
		{children}
	</List>
);

export default Wrapper;
